/* eslint-disable react/display-name */
import React, { forwardRef } from "react";

import { Box, CircularProgress, Grid } from "@mui/material";
import { VirtuosoGrid } from "react-virtuoso";

import EmptyState from "./EmptyState";

const GridListView = ({
  data,
  isLoading,
  renderItem,
  onLoadMore,
  renderHeader,
  emptyScreen,
  oneColumn,
  emptyTxt,
  containerStyle = {},
  containerGridStyle = {},
  itemContainerStyles = {},
  itemGridStyles = {},
  useImg2,
}) => {
  return (
    <VirtuosoGrid
      data={data || []}
      style={{ height: "100%", ...containerStyle }}
      increaseViewportBy={200}
      endReached={onLoadMore}
      components={{
        Header: renderHeader,
        List: forwardRef(({ style, children, ...props }, ref) => (
          <>
            {isLoading ? (
              <Box
                height="400px"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <CircularProgress />
              </Box>
            ) : data?.length === 0 ? (
              <>
                {emptyScreen ? (
                  emptyScreen
                ) : (
                  <EmptyState
                    useImg2={useImg2}
                    title={
                      emptyTxt ||
                      "No assessments found for the selected filters"
                    }
                    top="27%"
                    imageHeight={useImg2 ? "10px" : "400px"}
                  />
                )}
              </>
            ) : (
              <Grid
                ref={ref}
                container
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  ...style,
                }}
                {...containerGridStyle}
                {...props}
              >
                {children}
              </Grid>
            )}
          </>
        )),
        Item: ({ children, ...props }) => (
          <Grid
            item
            xs={12}
            sm={8}
            md={oneColumn ? 12 : 6}
            {...itemGridStyles}
            {...props}
            sx={{
              display: "flex",
              alignContent: "stretch",
              boxSizing: "border-box",
            }}
          >
            {children}
          </Grid>
        ),
      }}
      itemContent={(index, item) => (
        <ItemWrapper itemContainerStyles={itemContainerStyles}>
          {renderItem(index, item)}
        </ItemWrapper>
      )}
    />
  );
};

const ItemWrapper = ({ children, itemContainerStyles = {}, ...props }) => (
  <div
    {...props}
    style={{
      flex: 1,
      padding: ".7rem .7rem",
      ...itemContainerStyles,
    }}
  >
    {children}
  </div>
);

export default React.memo(GridListView);
